import { NgModule } from '@angular/core';

import { InspectionStatusPipe } from './inspection.status.pipe';

@NgModule({
  declarations: [
    InspectionStatusPipe
  ],
  providers: [
    InspectionStatusPipe,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'inspectionStatus',
      useClass: InspectionStatusPipe
    }
  ]
})
export class InspectionsModule {}